module.exports = __webpack_public_path__ + "static/img/sence-4-map.209e8a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sence-4-map.png
// module id = vqz/
// module chunks = 1